import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from '@tanstack/react-router';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { createQueryClient } from '@/api/queryClient';
import { applyTheme, readThemePreference } from '@/app/theme';
import { ConfirmProvider } from '@/components/ui/confirm-dialog';
import { TooltipProvider } from '@/components/ui/tooltip';
import { adoptFunnelJourneyIdFromUrl } from '@/lib/funnelJourney';
import { isAdminSurface } from '@/lib/surface';
import { createAppRouter } from '@/router/router';
import '@/styles/app.css';

applyTheme(readThemePreference());
// Before the router reads the URL, so `?funnel_journey_id=` never reaches it.
adoptFunnelJourneyIdFromUrl();

const queryClient = createQueryClient();
// Two route tables (parity §0): the admin console on the admin hosts, loaded
// as its own chunk; the customer product everywhere else.
const router = isAdminSurface()
  ? (await import('@/router/adminRouter')).createAdminRouter(queryClient)
  : createAppRouter(queryClient);

const container = document.getElementById('root');
if (!container) throw new Error('Missing #root');

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <ConfirmProvider>
          <RouterProvider router={router} />
        </ConfirmProvider>
      </TooltipProvider>
    </QueryClientProvider>
  </StrictMode>,
);
